import React from 'react';
import Section from '../Section';
import TitledContent from '../TitledContent';
import masks from '../../utils';
import { dateToStringFormat } from '../../utils/formatters';

const ConfirmPersonalData = ({
  clientName,
  clientSex,
  clientCPF,
  clientBirthdate,
  clientMaritalState,
  clientProfession,
  clientIndividualIncome,
  clientFamilyIncome,
}) => (
  <Section displayGrid title="Dados pessoais">
    <TitledContent fullWidth title="Nome" content={clientName} />
    <TitledContent title="Sexo" content={clientSex} />

    <TitledContent title="CPF" content={masks.cpf.mask(clientCPF)} />

    <TitledContent
      title="Data de nascimento"
      content={dateToStringFormat(clientBirthdate)}
    />
    <TitledContent title="Estado civil" content={clientMaritalState} />

    <TitledContent twoColumns title="Profissão" content={clientProfession} />
    <TitledContent
      title="Faixa de renda individual"
      content={clientIndividualIncome.descricao}
    />

    <TitledContent
      title="Faixa de renda familiar"
      content={clientFamilyIncome.descricao}
    />
  </Section>
);

export default ConfirmPersonalData;
